import { Injectable, Provider } from '@angular/core';

@Injectable()
export class StateParamsService {
  [param: string]: any;
}

export function StateParamsServiceFactory(i: any) {
  return i.get('$stateParams');
}

export const StateParamsServiceProvider: Provider = {
  provide: StateParamsService,
  useFactory: StateParamsServiceFactory,
  deps: [ '$injector' ],
};
